var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSetting = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  clipPath: "url(#clip0_8_2620)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Exposure"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M9.00005 15.3684C5.71905 15.3684 3.05005 12.6994 3.05005 9.41838C3.05005 6.13738 5.71905 3.46838 9.00005 3.46838C12.281 3.46838 14.95 6.13738 14.95 9.41838C14.95 12.6994 12.281 15.3684 9.00005 15.3684ZM9.00005 5.16838C6.65405 5.16838 4.75005 7.07238 4.75005 9.41838C4.75005 11.7644 6.65405 13.6684 9.00005 13.6684C11.346 13.6684 13.25 11.7644 13.25 9.41838C13.25 7.07238 11.346 5.16838 9.00005 5.16838Z",
  fill: "#414141"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M8.9999 5.1684C8.5324 5.1684 8.1499 4.7859 8.1499 4.3184V1.7684C8.1499 1.3009 8.5324 0.918396 8.9999 0.918396C9.4674 0.918396 9.8499 1.3009 9.8499 1.7684V4.3184C9.8499 4.7859 9.4674 5.1684 8.9999 5.1684Z",
  fill: "#414141"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M8.9999 17.9184C8.5324 17.9184 8.1499 17.5359 8.1499 17.0684V14.5184C8.1499 14.0509 8.5324 13.6684 8.9999 13.6684C9.4674 13.6684 9.8499 14.0509 9.8499 14.5184V17.0684C9.8499 17.5359 9.4674 17.9184 8.9999 17.9184Z",
  fill: "#414141"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_4",
  d: "M16.65 10.2684H14.1C13.6325 10.2684 13.25 9.88589 13.25 9.41839C13.25 8.95089 13.6325 8.56839 14.1 8.56839H16.65C17.1175 8.56839 17.5 8.95089 17.5 9.41839C17.5 9.88589 17.1175 10.2684 16.65 10.2684Z",
  fill: "#414141"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M3.9 10.2684H1.35C0.8825 10.2684 0.5 9.88589 0.5 9.41839C0.5 8.95089 0.8825 8.56839 1.35 8.56839H3.9C4.3675 8.56839 4.75 8.95089 4.75 9.41839C4.75 9.88589 4.3675 10.2684 3.9 10.2684Z",
  fill: "#414141"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M12.6041 6.66439C12.3831 6.66439 12.1706 6.57939 12.0006 6.41789C11.6691 6.08639 11.6691 5.55089 12.0006 5.21939L13.8026 3.41739C14.1341 3.08589 14.6696 3.08589 15.0011 3.41739C15.3326 3.74889 15.3326 4.28439 15.0011 4.61589L13.1991 6.41789C13.0291 6.58789 12.8166 6.66439 12.5956 6.66439H12.6041Z",
  fill: "#414141"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M3.59407 15.6744C3.37307 15.6744 3.16057 15.5894 2.99057 15.4279C2.65907 15.0964 2.65907 14.5609 2.99057 14.2294L4.79257 12.4274C5.12407 12.0959 5.65957 12.0959 5.99107 12.4274C6.32257 12.7589 6.32257 13.2944 5.99107 13.6259L4.18907 15.4279C4.01907 15.5979 3.80657 15.6744 3.58557 15.6744H3.59407Z",
  fill: "#414141"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M14.4061 15.6744C14.1851 15.6744 13.9726 15.5894 13.8026 15.4279L12.0006 13.6259C11.6691 13.2944 11.6691 12.7589 12.0006 12.4274C12.3321 12.0959 12.8676 12.0959 13.1991 12.4274L15.0011 14.2294C15.3326 14.5609 15.3326 15.0964 15.0011 15.4279C14.8311 15.5979 14.6186 15.6744 14.3976 15.6744H14.4061Z",
  fill: "#414141"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  d: "M5.39607 6.66439C5.17507 6.66439 4.96257 6.57939 4.79257 6.41789L2.99057 4.61589C2.65907 4.28439 2.65907 3.74889 2.99057 3.41739C3.32207 3.08589 3.85757 3.08589 4.18907 3.41739L5.99107 5.21939C6.32257 5.55089 6.32257 6.08639 5.99107 6.41789C5.82107 6.58789 5.60857 6.66439 5.38757 6.66439H5.39607Z",
  fill: "#414141"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_8_2620"
}, /*#__PURE__*/React.createElement("rect", {
  width: 17,
  height: 17,
  fill: "white",
  transform: "translate(0.5 0.918396)"
})))));
export default SvgIconSetting;